export const toSnakeCase = (str: string) =>
  str &&
  str
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g) // Match words
    .map(x => x.toLowerCase()) // Convert to lowercase
    .join('_'); // Join words with underscores

export const toCamelCase = (str: string) =>
  str
    .toLowerCase() // Convert the entire string to lowercase
    .replace(/[-_\s]+(.)?/g, (_, char) => (char ? char.toUpperCase() : ''));
